import { PureComponent } from 'react';
import { FormFieldProps } from 'ui/form/fields';
import { isValue } from 'ui/form/utils';

export class FormField<P, S> extends PureComponent<P | FormFieldProps, S> {
  static formfield: boolean = true;
  
  static get defaultValue() {
    throw new Error('Need to implement default value: ' + this.displayName);
  }
  
  /**
   * Get form fields errors
   * @abstract
   */
  static getErrors(props: P, formData): string | false {
    throw new Error('Not implemented: ' + this.constructor.name);
  }

  /**
   * Trigger validate
   * @abstract
   * @returns {true} - if input is valid
   */
  validate(onlyTouched: boolean): boolean {
    return true;
  }

  getValue() {
    const { value, default: def } = this.props;
    // if (this.props.value && this.props.value[name]) return this.props.value[name];
    
    if (isValue(value)) return value;
    else if (!isValue(value) && isValue(def)) return def;
    else return undefined;
  }
}
